









































































































































































































import { Component, Prop, Watch, Vue, Ref } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Vessel } from "@/types/vessel";
import { VesselGroup } from "@/types/vesselGroup";
import VesselGroupsClient from "Clients/vessel-groups-client";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import store from "@/store";
import SnackbarModule from "@/store/clients/Snackbar.module";
import DfiSelectMultiple from "../DfiForm/DfiSelectMultiple.vue";

const Snackbar = getModule(SnackbarModule, store);

@Component({
  components: {
    ConfirmDialog,
    DfiSelectMultiple,
  },
})
export default class VesselGroupCard extends Vue {
  @Prop({ required: true }) group!: VesselGroup;
  @Prop({ required: true }) vessels!: Vessel[];
  
  @Ref("confirmDelete") confirmDelete!: any;
  @Ref("confirmDeleteVessel") confirmDeleteVessel!: any;

  newVessels: Vessel[] = [];
  isEditMode = false;
  newGroupName = "";
  isUpdating = false;
  isDeleting = false;
  addingVessels = false;
  deletingVesselId: number | null = null;

  get vesselsInGroup(): Vessel[] {
    return this.vessels.filter(vessel => this.group.vesselIds.includes(vessel.id));
  }

  get vesselsNotInGroup(): Vessel[] {
    return this.vessels.filter(vessel => !this.group.vesselIds.includes(vessel.id));
  }

  get applyButtonIcon(): string {
    return this.isUpdating ? "mdi-loading" : "mdi-check";
  }

  @Watch('group')
  onGroupChange() {
    this.newGroupName = this.group.name;
  }

  mounted() {
    this.newGroupName = this.group.name;
  }

  enableNameEdit() {
    this.isEditMode = true;
  }

  async applyNewGroupName() {
    try {
      await VesselGroupsClient.update({ ...this.group, name: this.newGroupName });
    } catch (e) {
      console.error("Failed to update group name", e);
      return;
    }

    this.cancelNameEdit();
  }

  cancelNameEdit() {
    this.isEditMode = false;
  }

  async addVesselsToGroup() {
    if (this.newVessels.length === 0) return;

    this.addingVessels = true;

    try {
      const addVessel = (vessel: Vessel) => VesselGroupsClient.addVesselToGroup(vessel, this.group);

      await Promise.allSettled(this.newVessels.map(addVessel));

      const groupsData = await VesselGroupsClient.getAll();
      const updatedGroup = groupsData.find((group: VesselGroup) => group.id === this.group.id);
      this.$emit("update", updatedGroup);

      Snackbar.showSnackbar({
        text: `Vessels were <b>added</b> to the group`,
        color: "success",
      });
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to add vessels to the group" });
    } finally {
      this.addingVessels = false;
      this.newVessels = [];
    }
  }

  async deleteVessel(vessel: Vessel) {
    const confirmed = await this.confirmDeleteVessel.open(
      "Delete Vessel from Group",
      `Are you sure you want to delete the vessel "${vessel.name}" from group "${this.group.name}"?`,
      {
        width: 500,
        titleClasses: "px-6 pt-6 pb-0",
      }
    );

    if (!confirmed) {
      return;
    }

    try {
      this.deletingVesselId = vessel.id;
      const updatedGroup = await VesselGroupsClient.removeVesselFromGroup(vessel, this.group);
      Snackbar.showSnackbar({ text: "Vessel successfully removed from group", color: "success" });
      this.$emit("update", updatedGroup);
    } catch (e) {
      console.error("Failed to remove vessel from group", e);
      Snackbar.showSnackbar({ text: "Failed to remove vessel from group" });
      return;
    }

    this.deletingVesselId = null;
  }

  async deleteGroup() {
    const confirmed = await this.confirmDelete.open(
      "Delete Vessel Group",
      `Are you sure you want to delete this Vessel Group “${this.group.name}”?`,
      {
        width: 500,
        titleClasses: "px-6 pt-6 pb-0",
      }
    );

    if (!confirmed) {
      return;
    }

    try {
      this.isDeleting = true;
      await VesselGroupsClient.remove(this.group);
      Snackbar.showSnackbar({ text: "Vessel group successfully deleted", color: "success" });
      this.$emit("delete");
    } catch (e) {
      console.error("Failed to delete group", e);
      Snackbar.showSnackbar({ text: "Failed to delete vessel group" });
      return;
    }

    this.isDeleting = false;
  }
}
